import dayjs from 'dayjs';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Page } from 'react-facebook';
import { useQuery } from 'react-query';
import { useParams, useSearchParams } from 'react-router-dom';
import { Image, Loading, Typography } from 'tfc-components';

import Icon from 'components/atoms/Icon';
import NewsCard from 'components/molecules/NewsCard';
import Section from 'components/organisms/Section';
import useWindowDimensions from 'hooks/useWindowDemensions';
import { getNewDetailService, getPreviewNewsService } from 'services/news';

const NewsDetail: React.FC = () => {
  const { width, height } = useWindowDimensions();
  const { slug } = useParams<{ slug: string }>();
  const [searchParams] = useSearchParams();
  const previewCode = searchParams.get('preview');

  const { data: newsDetail, isLoading, error } = useQuery({
    queryKey: ['newsDetail', slug],
    queryFn: () => (previewCode ? getPreviewNewsService({ endPoint: 'news', previewCode, locale: 'vi' }) : getNewDetailService({ slug: slug || '', locale: 'vi' })),
    enabled: !!slug || !!previewCode,
  });
  if (isLoading) {
    return (
      <div className="loading-main" style={{ width, height }}>
        <Loading.CircleDashed color="#F96619" width={48} />
      </div>
    );
  }
  if (error) {
    return (
      <Section>
        <Typography.Text textStyle="center" extendClasses="fs-44x54" fontweight="700">404</Typography.Text>
      </Section>
    );
  }
  return (
    <Section className="p-newsDetail">
      <Row>
        <Col md={8} sm={12}>
          <Typography.Heading type="h2" extendClasses="fs-28x34 p-newsDetail_title" fontweight="700">
            {newsDetail?.translations?.vi?.title}
          </Typography.Heading>
          <div className="p-newsDetail_dateWrap">
            <div className="p-newsDetail_date">
              <span><Icon iconName="calendarBlankGray" size="16" /></span>
              <Typography.Text extendClasses="p-newsDetail_dateText fs-14x16">
                {dayjs(newsDetail?.newsData?.publishedAt || '').format('DD/MM/YYYY')}
              </Typography.Text>
            </div>
            <div className="p-newsDetail_date">
              <span><Icon iconName="clockGray" size="16" /></span>
              <Typography.Text extendClasses="p-newsDetail_dateText fs-14x16">
                {dayjs(newsDetail?.newsData?.publishedAt || '').format('HH:mm:ss')}
              </Typography.Text>
            </div>
          </div>
          <Typography.Text extendClasses="p-newsDetail_description fs-18x24">
            {newsDetail?.translations?.vi?.description}
          </Typography.Text>
          <Image extendClasses="p-newsDetail_thumbnail" imgSrc={newsDetail?.translations?.vi?.thumbnail.path || ''} alt={newsDetail?.translations?.vi?.thumbnail.alt || ''} ratio={796 / 447} />
          <div className="p-newsDetail_content">
            <div dangerouslySetInnerHTML={{ __html: newsDetail?.translations?.vi?.content || '' }} />
          </div>
        </Col>
        <Col md={4} sm={12}>
          {newsDetail?.relatedByNews && newsDetail?.relatedByNews?.length > 0 && (
            <div className="p-blog_sidebar_box">
              <div className="p-blog_sidebar_header">
                <Icon iconName="newsPaperOrange" size="30" />
                <Typography.Text extendClasses="fs-24x30" fontweight="600">
                  Bài viết liên quan
                </Typography.Text>
              </div>
            </div>
          )}
          <div className={newsDetail?.relatedByNews && newsDetail?.relatedByNews?.length > 0 ? 'p-newsDetail_related' : ''}>
            {newsDetail?.relatedByNews?.map((news) => (
              <NewsCard
                key={news?.slug}
                img={news?.thumbnail?.path}
                imgAlt={news?.thumbnail?.alt}
                title={news?.title}
                dateTime={news?.publishedAt}
                link={`/tin-tuc/${news?.slug}`}
                target="_self"
              />
            ))}
          </div>
          <div className={newsDetail?.relatedByNews && newsDetail?.relatedByNews?.length > 0 ? 'p-newsDetail_cardWrap' : ''}>
            <Page
              href="https://www.facebook.com/evollabs/"
              tabs="timeline,events,messages"
              width={385}
              height={500}
            />
          </div>
        </Col>
      </Row>
    </Section>
  );
};

export default NewsDetail;
